// extracted by mini-css-extract-plugin
module.exports = {"customSlider":"ImageSlider_customSlider__3AdTc","sliderImage":"ImageSlider_sliderImage__fJIHS"};